import React, { useEffect, useState } from "react";
import { useDishes } from "../DishesContext";
import { useAllergens, usePreservatives } from "../AllergensContext";
import { Carousel, Flex } from "antd-mobile";
import { Col, Rate, Row, Typography } from "antd";
import {
  CheckSquareOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useSpiceLevels } from "../../../../../DigitalMenu/SpiceLevelCtx";
import Chilli from '../../../../../../static/Chili';
import DishIcon from '../../../../../../static/DishIcon';
import PriceTag from "../../../../../../static/PriceTag";

const { Text, Title, Paragraph } = Typography;


const IconPlaceHolder = ({vertical, className}) => {
  if (vertical === 3) return <DishIcon className={className} />
  return <PriceTag className={className} />
}

function Dishes(props) {
  const _dishes = useDishes();
  const [dishes, setDishes] = useState(_dishes);
  const allergens = useAllergens();
  const preservatives = usePreservatives();
  const [_allergens, _setAllergens] = useState({});
  const [_preservatives, _setPreservatives] = useState({});
  const searchQuery = useSelector(state => state.digitalMenuConfig.searchQuery);
  const { allergensPreservativesFilters } = useSelector(state => state.digitalMenuConfig);
  const spiceFilter = useSelector(state => state.digitalMenuConfig.spiceFilter);
  const vertical = useSelector(state => state.companyConfig.vertical_id);
  const spiceLevels = useSpiceLevels();
  const verticalId = useSelector(state => state.companyConfig.vertical_id);


  const filterText = (toFilter) => {
    let filteredDishes = [];
    if (searchQuery === null) {
      return toFilter;
    }
    if (searchQuery.length > 0) {
      filteredDishes = toFilter.map((category) => {
        let _category = Object.assign({}, category);
        if (_category.dishes.length > 0) {
          _category.dishes = _category.dishes.filter((aDish) => {
            return aDish.dish_name.toUpperCase().indexOf(searchQuery.toUpperCase()) > -1;
          });
        }
        return _category;
      }).filter((category) => category.dishes.length > 0);
      return filteredDishes;
    }
  };

  const filterAllergensPreservatives = (toFilter) => {
    if (allergensPreservativesFilters.length === 0) return toFilter;

    const filtersIds = allergensPreservativesFilters.map(filter => filter.id);
    let filteredDishes = toFilter.map(category => {
      let _category = Object.assign({}, category);
      if (_category.dishes.length > 0) {
        _category.dishes = _category.dishes.filter(aDish => {
          return !aDish.allergens.some(allergen => {
            return filtersIds.includes(allergen.allergen_id);
          });
        });
      }
      return _category;
    }).filter((category) => category.dishes.length > 0);
    return filteredDishes;
  };

  const filterSpiceLevel = (toFilter) => {
    if (spiceFilter === 0) return toFilter;

    const filteredDishes = toFilter.map(category => {
      let _category = Object.assign({}, category);
      if (_category.dishes.length > 0) {
        _category.dishes = _category.dishes.filter(aDish => {
          return aDish.spice_level === spiceFilter;
        });
      }
      return _category;
    }).filter((category) => category.dishes.length > 0);
    return filteredDishes;
  }

  useEffect(() => {
    if (_dishes.length > 0) {
      let toFilter = Array.from(_dishes);

      if (spiceFilter && spiceFilter >= 0) {
        toFilter = filterSpiceLevel(toFilter);
      }

      if (allergensPreservativesFilters && allergensPreservativesFilters.length > 0) {
        toFilter = filterAllergensPreservatives(toFilter);
      }

      if (searchQuery && searchQuery.length > 0) {
        toFilter = filterText(toFilter);
      }
      setDishes(toFilter);
    }
  }, [
      allergensPreservativesFilters,
      searchQuery,
      spiceFilter,
    ]);

  useEffect(() => {
    setDishes(_dishes);
  }, [_dishes]);


  useEffect(() => {
    if (allergens) {
      const transformedAllergens = {};
      allergens.map((allergen) => {
        transformedAllergens[allergen.id] = allergen.name;
      });
      _setAllergens(transformedAllergens);
    }
    if (preservatives) {
      const transformedPreservatives = {};
      preservatives.map((preservative) => {
        transformedPreservatives[preservative.id] = preservative.name;
      });
      _setPreservatives(transformedPreservatives);
    }
  }, [allergens, preservatives]);

  const [selectedDish, setSelectedDish] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [imgHeight, setImgHeightState] = useState(0);

  const expandDish = (indexCat, indexDish) => {
    setSelectedDish(indexDish);
    setSelectedCategory(indexCat);
  };

  const numberWithCommas = (number) => 
    parseFloat(number).toLocaleString('de-DE',  { minimumFractionDigits: 2 });

  const buildPrice = (prices) => {
    if (prices === null) return '';
    let priceString = `€`
    const priceKeys = Object.keys(prices);
    if (priceKeys.length === 1) {
      return (
        <Flex.Item
        className="single-price"
        style={{
          flex: "0 0 25%",
          margin: '3px 0px'
        }}>
          <div>{priceString + numberWithCommas(prices.default)}</div>
        </Flex.Item>)
    } else {
      return priceKeys.map(priceKey => (
        <Flex.Item
        className="multi-price"
        style={{
          flex: "1 0 25%",
        }}>
          <Flex direction="row" justify="center" style={{height: "100%"}}>
            <Flex.Item>
            {`${priceKey}
            ${priceString + numberWithCommas(prices[priceKey])}`}
            </Flex.Item>
          </Flex>
        </Flex.Item>
      ));
    }
  }

  return (
    <div className="dishes-wrapper">
      <Row justify="center">
        <Col md={0} lg={6}></Col>
        <Col md={24} lg={12} className="dish-container">
          {dishes.map((category, indexCat) => (
            <section key={`category-${indexCat}`} id={category.key}>
              <div className="m-t-32">
                <Title level={4}>{category.category_name}</Title>
              </div>
              {category.dishes.map((dish, indexDish) => {
                let shouldHide = false;
                if (selectedDish === indexDish && selectedCategory === indexCat) {
                  shouldHide = true;
                }

                return (
                  <>
                    <Flex
                      className={`dish m-t-12 ${shouldHide ? "remove" : ""}`}
                      justify="start"
                      alignContent="stretch"
                      key={`dish-${dish.dish_id}`}
                      onClick={() => expandDish(indexCat, indexDish)}
                    >
                      <Flex.Item className="relative">
                        { dish.dish_images[0] &&
                          <div style={{"background-image": `url(${dish.dish_images[0]})`}} className="dish-thumb"></div>
                        }
                        { !dish.dish_images[0] &&
                          <IconPlaceHolder vertical={vertical} className="dish-icon-placeholder" />
                        }
                      </Flex.Item>
                      <Flex.Item className="dish-body">
                        <Flex>
                          <Flex.Item>
                            <div className="dish-title">
                              <span className="float-right m-r-12">
                                <DownOutlined />
                              </span>
                              <span className="break-word">{dish.dish_name}</span>
                            </div>
                          </Flex.Item>
                        </Flex>
                        { dish.description &&
                          <Flex>
                            <Flex.Item>
                              <div className="dish-description">{dish.description}</div>
                            </Flex.Item>
                          </Flex>
                        }
                        <Flex className="dish-price" wrap="wrap" align="stretch" >
                          {buildPrice(dish.dish_price)}
                        </Flex>
                      </Flex.Item>
                    </Flex>
                    <Flex
                      className={`dish m-t-12 p-b-12 ${
                        shouldHide ? "" : "remove"
                      } expanded`}
                      justify="start"
                      key={`dish-expanded-${dish.dish_id}`}
                    >
                      <Flex.Item className="dish-body">
                        <div
                          className="dish-title expanded m-l-6"
                          onClick={() => expandDish(null, null)}
                        >
                          <span className="float-right">
                            <UpOutlined />
                          </span>
                          <span className="break-word">{dish.dish_name}</span>
                        </div>
                        {(shouldHide && dish.dish_images.length >0) && (
                          <Flex>
                            <Flex.Item>
                              <div className="dish-carousel-wrapper">
                                <Carousel
                                  frameOverflow="visible"
                                  cellSpacing={10}
                                  slideWidth={0.8}
                                  infinite
                                >
                                  {dish.dish_images.map((img, indexImg) => {
                                    return (
                                      <img
                                        src={img}
                                        className="dish-carousel-img"
                                        alt=""
                                        onLoad={() => {
                                          // fire window resize event to change height
                                          window.dispatchEvent(new Event("resize"));
                                          setImgHeightState("auto");
                                        }}
                                      />
                                    );
                                  })}
                                </Carousel>
                              </div>
                            </Flex.Item>
                          </Flex>
                        )}
                        { dish.description &&
                          <Flex>
                            <Flex.Item className="m-l-6 m-t-12 ">
                              <Paragraph className="all-white-wpaces-preserved">{dish.description}</Paragraph>
                            </Flex.Item>
                          </Flex>
                        }
                        <Flex className="dish-price expanded m-l-6 m-b-6" wrap="wrap">
                          {buildPrice(dish.dish_price)}
                        </Flex>
                        { (verticalId === 3 && dish.spice_level > 0) &&
                          <Flex>
                            <Flex.Item>
                              <Text strong className="m-l-4">Schärfegrad: </Text>
                              <Rate
                                allowClear
                                defaultValue={dish.spice_level}
                                count={spiceLevels.length}
                                className="chilli m-l-12"
                                disabled
                                character={<Chilli />}
                              />
                            </Flex.Item>
                          </Flex>
                        }
                        { verticalId === 3 &&
                          <Flex className="m-l-4 m-r-4 m-t-6 allergens-wrapper" wrap="wrap">
                            {
                              dish.allergens.some(al => !al.is_preservative) &&
                              <div>
                                <Text strong>Allergene: </Text>
                                {dish.allergens.reduce((acc, al) => {
                                  if (!al.is_preservative) {
                                    acc.push(
                                      <Flex.Item className="allergens" key={_allergens[al.allergen_id]}>
                                        <div>
                                          <span>
                                            <CheckSquareOutlined />
                                          </span>
                                          <span className="m-l-4">{_allergens[al.allergen_id]}</span>
                                        </div>
                                      </Flex.Item>
                                    );
                                  }
                                  return acc;
                                }, [])}
                              </div>
                            }
                          </Flex>
                        }
                        {
                          verticalId === 3 &&
                          <Flex className="m-l-4 m-r-4 m-t-6 allergens-wrapper" wrap="wrap">
                            {
                              dish.allergens.some(al => al.is_preservative) &&
                              <div>
                                <Text strong>Inhaltsstoffe: </Text>
                                {dish.allergens.reduce((acc, al) => {
                                  if (al.is_preservative) {
                                    acc.push(
                                      <Flex.Item className="allergens" key={_preservatives[al.allergen_id]}>
                                        <div>
                                          <span>
                                            <CheckSquareOutlined />
                                          </span>
                                          <span className="m-l-4">{_preservatives[al.allergen_id]}</span>
                                        </div>
                                      </Flex.Item>
                                    );
                                  }
                                  return acc;
                                }, [])}
                              </div>
                            }
                          </Flex> 
                        }
                      </Flex.Item>
                    </Flex>
                  </>
                );
              })}
            </section>
          ))}
        </Col>
        <Col md={0} lg={6}></Col>
      </Row>
    </div>
  );
}

export default Dishes;
